import { fetchRestResponse } from '../../../common/fetch/fetch-rest-reponse';
import { logger } from '../../../common/utils/logger';

import type { ObjectResolverDataType, ObjectResolverParamType } from './types';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getAdminhubLink } from './get-adminhub-link';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { convertToKeyPhraseInputFormat } from './convert-to-key-phrase-input-format';

const OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';

export const fetchObjectResolver: (url: string) => Promise<import('./types').Data | null> = async (
	url: string,
) => {
	try {
		const objectResolver = await fetchRestResponse<
			ObjectResolverParamType[],
			ObjectResolverDataType[]
		>({
			url: OBJECT_RESOLVER_ENDPOINT,
			body: [{ resourceUrl: url }],
		});

		if (!objectResolver || objectResolver[0].status !== 200) {
			logger.error({ error: 'REQUEST ERROR', functionName: 'convertToKeyPhraseInputFormat' });
			return null;
		}

		return objectResolver[0].body.data;
	} catch (error) {
		logger.error({ error, functionName: 'convertToKeyPhraseInputFormat' });
		return null;
	}
};
